import type { IInput } from './Input';

import Input from './Input';

export type { IInput };
export default Input;
